import React, { useState, useEffect } from 'react';
import { Col, Row, Space } from 'antd';

import Edit from '../../../../assets/icons/Edit/Edit';
import Delete from '../../../../assets/icons/Delete/Delete';
import { ModalAttendance } from '../../../../components/ModalAttendance';
import { useMatrizConsulta } from './context';
import * as S from '../styles.js';
import * as E from './styles.js';

import arrowRigth16 from '../../../../assets/icons/arrowRigth16.svg';

export function TabelaListagem({ list }) {
  const {
    deleteMatriz,
    updateEditMatriz,
    updateOpenForm,
    updateMatrizItemEdit,
  } = useMatrizConsulta();
  const [lista, setLista] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [matriz, setMatriz] = useState(null);
  const [disableForm] = useState(true);

  const titleModal = `Deseja excluir a Matriz ${matriz?.nome || ''}?`;

  useEffect(() => {
    setLista(list);
  }, [list]);

  const styleLocal = {
    input: {
      background: '#F2F2F2',
      border: 'none',
      height: '48px',
    },
    rowTop: {
      width: '100%',
      marginTop: '0px',
      display: 'flex',
    },
    colWithe: {
      background: '#fff',
      borderRadius: '2px',
      height: 'fit-content',
      paddingRight: '5px',
    },
    internCol: {
      borderRadius: '2px',
      overflowY: 'auto',
      background: '#fff',
      padding: '20px 0px 16px 0',
      overflowX: 'hidden',
    },
    internCol2: {
      borderRadius: '2px',
      overflowY: 'auto',
      background: '#fff',
      padding: '42px 28px 0 28px',
      overflowX: 'hidden',
    },
    alterButton: {
      cursor: 'pointer',
      fontSize: '14px',
      lineHeight: '16px',
      textAlign: 'center',
      color: '#24A95D',
      fontWeight: 'bold',
      margin: '14px 0',
      textDecoration: 'underline #24A95D',
    },
    formItem: {
      fontWeight: 'bold',
      fontSize: '14px',
      lineHeight: '16px',
      color: '#707070',
      margin: '10px 0',
    },
    checkStyle: {
      fontWeight: 'bold',
      fontSize: '14px',
      lineHeight: '16px',
      color: '#707070',
      margin: '0px 0 15px 0',
    },
    formItemButton: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
    },
  };

  function ArrowRigth() {
  return <img src={arrowRigth16} alt="arrow" />;
}

  const edit = item => {
    setActiveId(item.id);
    updateEditMatriz(true);
    updateOpenForm(true);
    updateMatrizItemEdit(item);
  };

  const remove = item => {
    setMatriz(item);
    toggleModal();
  };

  const toggleModal = () => setIsModalVisible(!isModalVisible);

  const cancelModal = () => toggleModal();

  const okModal = () => {
    toggleModal();
    deleteMatriz(matriz?.id);
  };
  const [activeId, setActiveId] = useState(0);

  function RowsForUsers({ item }) {
    return (
      <S.RowsForColumn active={activeId === item.id}>
        <S.RowData key={item.id} justify="center">
          <S.StyledColRow span={7} onClick={() => edit(item)}>
            {item.nome}
          </S.StyledColRow>
          <S.StyledColRow span={7} onClick={() => edit(item)}>
            {item.cliente.nomeFantasia}
          </S.StyledColRow>

          <S.StyledColRow span={4} onClick={() => edit(item)}>
            <Editar acton={item} />
          </S.StyledColRow>
          <S.StyledColRow span={4}>
            <Excluir acton={item} />
          </S.StyledColRow>
          <S.StyledColRow span={2}>
            <ArrowRigth />
          </S.StyledColRow>
        </S.RowData>
      </S.RowsForColumn>
    );
  }

  function RowUsers() {
    return (
      <Col span={24} style={{ marginTop: '40px' }}>
        {lista?.map((item, i) => <RowsForUsers key={i} item={item} />)}
      </Col>
    );
  }

  function Editar({ acton }) {
    return (
      <E.BoxAcoes
        style={{
          justifyContent: 'flex-end',
        }}
      >
        <Space
          style={{
            padding: '0 4px',
            marginRight: 4,
          }}
        >
          <Edit onClick={() => edit(acton)} />
        </Space>
      </E.BoxAcoes>
    );
  }

  function Excluir({ acton }) {
  return <E.BoxAcoes
    style={{
        justifyContent: 'flex-end',
      }}
  >
      <Space
        style={{
          padding: '0 4px',
        }}
      >
        <Delete onClick={() => remove(acton)} />
      </Space>
         </E.BoxAcoes>;
}
  return (
    <E.ContainerTable>
      <ModalAttendance
        title={titleModal}
        visible={isModalVisible}
        cancelBtn={cancelModal}
        okBtn={okModal}
      />
      <Row justify="center" id="row" style={styleLocal.rowTop}>
        <Col
          span={disableForm ? 24 : 12}
          style={{
            paddingRight: disableForm ? 0 : 24,
            marginTop: '0px',
          }}
        >
          <Col style={styleLocal.colWithe}>
            <Row
              id="fixe"
              style={{
                position: 'absolute',
                width: '100%',
                background: '#fff',
                zIndex: '1',
                padding: '0',
              }}
              span={24}
            >
              <Row
                span={24}
                style={{
                  position: 'relative',
                  width: '100%',
                  background: '#fff',
                  zIndex: '1',
                  marginTop: '5px',
                }}
              >
                <S.RowTitle
                  style={{
                    width: '100%',
                    background: '#fff',
                    borderBottom: '2px solid #CACACA',
                    marginBottom: '3px',
                    color: '#001F2A',
                    fontSize: '12px',
                  }}
                >
                  <S.StyledColTitle span={7}>Matriz</S.StyledColTitle>
                  <S.StyledColTitle span={7}>Cliente</S.StyledColTitle>
                  <S.StyledColTitle span={4}>Editar</S.StyledColTitle>
                  <S.StyledColTitle span={4}>Excluir</S.StyledColTitle>
                  <S.StyledColTitle span={2} />
                </S.RowTitle>
              </Row>
            </Row>
            <Col
              justify="center"
              id="col"
              span={24}
              style={styleLocal.internCol}
            >
              <RowUsers />
            </Col>
          </Col>
        </Col>
      </Row>
    </E.ContainerTable>
  );
}
